import { CustomizedCadenceBulkAccountLoader } from '@drift-labs/sdk';
import { Connection } from '@solana/web3.js';
import Env from 'src/environmentVariables/EnvironmentVariables';

export const generateAccountLoader = (connection: Connection) => {
	// DO NOT CHANGE THE INSTANCE OF BULK ACCOUNT LOADER. The app relies on the CustomizedCadenceBulkAccountLoader to handle the polling of accounts at different frequencies.
	// Other parts of the app also assume we are using the CustomizedCadenceBulkAccountLoader.
	const accountLoader = new CustomizedCadenceBulkAccountLoader(
		connection,
		Env.defaultCommitmentLevel,
		Env.pollingFrequencyMs
	);
	return accountLoader;
};
